



































































































import DictMixin from '@/mixins/dict-mixin';
import DimensionServices, { DimensionItemDto } from '@/services/dimension';
import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class DimensionForm4 extends mixins(DictMixin) {
  @PropSync('def') syncDefs!: any;
  @Prop() itemLists!: DimensionItemDto[];
  dimSrv = new DimensionServices();

  @Watch('syncDefs', { immediate: false, deep: true })
  onSyncDimSyncDefschange(newVal: any, oldVal: any) {
    if (newVal.databaseConfig.source.databaseName != oldVal.databaseConfig.source.databaseName) {
      this.changeDatabase(newVal.databaseConfig.source.databaseName);
    }
    if (newVal.databaseConfig.source.tableName != oldVal.databaseConfig.source.tableName) {
      this.changeTable(newVal.databaseConfig.source.tableName);
    }
    if (newVal.databaseConfig.mappings.length > 0) {
      this.mappings = newVal.databaseConfig.mappings;
      this.syncMapping();
    }
  }

  @Watch('itemLists', { immediate: false, deep: true })
  onDimFieldListChange() {
    setTimeout(() => {
      this.resetMappings();
    }, 100);
  }

  resetMappings() {
    // 删除属性重置映射
    if (this.itemLists.length !== this.mappings.length) {
      this.mappings = this.itemLists.map((v: any) => ({
        checked: true,
        sink: v.fieldCode,
        sinkName: v.fieldName,
        sort: 0,
        source: '',
        type: v.fieldType
      }));
      this.syncMapping();
      return false;
    }
    // 变更属性映射
    this.itemLists.forEach((v: any, index: number) => {
      if (this.mappings[index]?.sink !== v.fieldCode) {
        this.$set(this.mappings, index, {
          checked: true,
          sink: v.fieldCode,
          sinkName: v.fieldName,
          sort: 0,
          source: '',
          type: v.fieldType
        });
      } else {
        this.mappings[index].sinkName = v.fieldName;
        this.mappings[index].type = v.fieldType;
      }
    });
    this.syncMapping();
  }

  syncType = ['增量同步', '全量同步'];

  databases: string[] = [];
  async created() {
    let res = await this.dimSrv.getDatabaseList();
    this.databases = res.databases;
  }
  spinning: boolean = false;
  activeDatabase: string = '';
  tables: any[] = [];
  async changeDatabase(e: string) {
    if (!e) return false;
    this.activeDatabase = e;
    this.spinning = true;
    let res = await this.dimSrv.getTableList(e);
    this.tables = res.tables;
    this.spinning = false;
  }

  fieldList: any[] = [];
  async changeTable(e: string) {
    if (!e) return false;
    this.spinning = true;
    let res = await this.dimSrv.getColumnsList(this.activeDatabase, e);
    this.fieldList = res.columns;
    this.spinning = false;
  }

  changeSyncField(e: string) {
    let field = this.fieldList.find((v: any) => v.name === e);
    this.syncDefs.incrementSyncFieldType = field.type;
  }

  databaseConfig = {
    mappings: [
      {
        checked: true,
        sink: '', // 属性
        sort: 0,
        source: '', // 数据对象表字段
        type: '' // 属性类型
      }
    ],
    source: {
      databaseName: '', // 数据资源
      sourceId: 0,
      sourceName: '', // 数据源
      tableName: '' // 数据对象
    }
  };

  sameNameMapping() {
    this.mappings.forEach((v: any, index: number) => {
      if (this.fieldList.find((f: any) => f.name === v.sink)) {
        this.mappings[index].source = v.sink;
      }
    });
    this.syncMapping();
  }

  allowDrop(e: any) {
    e.preventDefault();
  }

  dragField: any = {};
  dragstart(dragField: any) {
    this.dragField = dragField;
  }

  removeField(index: number) {
    this.mappings[index].source = '';
    this.syncMapping();
  }

  mappings: any[] = [];
  drop(index: number) {
    this.mappings[index].source = this.dragField.name;
    this.syncMapping();
  }

  syncMapping() {
    this.syncDefs.databaseConfig.mappings = this.mappings;
  }

  filterOption(input: string, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
}
